/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {GenericObject} from '@ion/core/src/types/entities';
import {EXPORT_REQUEST} from '../actions/exporter';
import {EntityExportState} from '../reducers/exporter';

const selectCurrent       = ({exporter: {current}}) => current;
const selectPendingExport = ({exporter: {current: {pending}}}) => pending;

export const pendingExportSelector = createDeepEqualSelector(selectPendingExport,
  (pending: GenericObject): GenericObject => pending
);

export const exporterCurrentSelector = createDeepEqualSelector(selectCurrent,
  (current: EntityExportState): EntityExportState => current
);

export const enableExportLimit = (exportLimit: number) => ({
  type : EXPORT_REQUEST, exportLimit
});
